import { FC, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { useCourseDeliveryCountsQuery } from 'src/hooks/useCourseDeliveryCounts.query';

import CourseDeliveryCountReportPresenter from './CourseDeliveryCountReportPresenter';
import { useIssueDateTime } from './reports/useIssueDateTime';

/**
 * コース別配送件数リストのページ。
 * `/course-delivery-counts?start_on=YYYY-MM-DD&end_on=YYYY-MM-DD` で表示される。
 */
const CourseDeliveryCountReport: FC = memo(() => {
  const query = new URLSearchParams(useLocation().search);
  const startOn = query.get('start_on') ?? '';
  const endOn = query.get('end_on') ?? '';

  const { data, isLoading, isError } = useCourseDeliveryCountsQuery({ startOn, endOn });
  const { issueDate, issueTime } = useIssueDateTime();

  return (
    <CourseDeliveryCountReportPresenter
      data={data}
      isLoading={isLoading}
      isError={isError}
      issueDate={issueDate}
      issueTime={issueTime}
    />
  );
});

export default CourseDeliveryCountReport;
